
import { useState } from "react";
import { SearchBar } from "./search/SearchBar";
import { SkillsFilter } from "./search/SkillsFilter";
import { StatusFilter } from "./search/StatusFilter";
import { FunctionFilter } from "./search/FunctionFilter";
import { FavoriteFilter } from "@/components/common/FavoriteFilter";
import { FilterBadges } from "./search/FilterBadges";

interface CandidatesSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  skillsFilter: string[];
  setSkillsFilter: (skills: string[]) => void;
  skillsOperator: "AND" | "OR";
  setSkillsOperator: (operator: "AND" | "OR") => void;
  statusFilter: string[];
  setStatusFilter: (status: string[]) => void;
  functionFilter: string;
  setFunctionFilter: (functionName: string) => void;
  showFavoritesOnly: boolean;
  setShowFavoritesOnly: (show: boolean) => void;
  allSkills: string[];
  allStatuses: string[];
  onSkillsFilterOpen?: () => void;
}

export const CandidatesSearch = ({ 
  searchTerm, 
  setSearchTerm,
  skillsFilter,
  setSkillsFilter,
  skillsOperator,
  setSkillsOperator,
  statusFilter,
  setStatusFilter,
  functionFilter,
  setFunctionFilter,
  showFavoritesOnly,
  setShowFavoritesOnly,
  allSkills,
  allStatuses,
  onSkillsFilterOpen
}: CandidatesSearchProps) => {
  
  // Toggle skill selection
  const toggleSkill = (skill: string) => {
    if (skillsFilter.includes(skill)) {
      setSkillsFilter(skillsFilter.filter(s => s !== skill));
    } else {
      setSkillsFilter([...skillsFilter, skill]);
    }
  };
  
  // Toggle status selection
  const toggleStatus = (status: string) => {
    if (statusFilter.includes(status)) {
      setStatusFilter(statusFilter.filter(s => s !== status));
    } else {
      setStatusFilter([...statusFilter, status]);
    }
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSkillsFilter([]);
    setSkillsOperator("AND");
    setStatusFilter([]);
    setFunctionFilter("");
  };

  return (
    <div className="flex-1" data-tour="candidates-search">
      <div className="flex flex-col sm:flex-row gap-3">
        <SearchBar 
          searchTerm={searchTerm} 
          setSearchTerm={setSearchTerm} 
        />
        
        <div className="flex gap-2">
          <SkillsFilter
            skillsFilter={skillsFilter}
            setSkillsFilter={setSkillsFilter}
            skillsOperator={skillsOperator}
            setSkillsOperator={setSkillsOperator}
            allSkills={allSkills}
            onOpen={onSkillsFilterOpen}
          />
          
          <StatusFilter 
            statusFilter={statusFilter} 
            setStatusFilter={setStatusFilter} 
          />
          
          <FunctionFilter 
            functionFilter={functionFilter} 
            setFunctionFilter={setFunctionFilter} 
          />
          
          <FavoriteFilter
            showFavoritesOnly={showFavoritesOnly}
            setShowFavoritesOnly={setShowFavoritesOnly}
          />
        </div>
      </div>
      
      <FilterBadges
        skillsFilter={skillsFilter}
        skillsOperator={skillsOperator}
        toggleSkill={toggleSkill}
        statusFilter={statusFilter}
        toggleStatus={toggleStatus}
        functionFilter={functionFilter}
        setFunctionFilter={setFunctionFilter}
        clearAllFilters={clearAllFilters}
      />
    </div>
  );
};
